import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export const IST_TIME_ZONE_ID: Uuid = "78e7c5ba-3769-4f38-a176-c52a2ab14098" as Uuid;
